// import React, { useEffect, useState } from 'react'
// import Container from 'react-bootstrap/esm/Container'
// import Table from 'react-bootstrap/esm/Table'
// import { StagesTypeActions } from './StagesTypeActions'
// import { useDispatch, useSelector } from 'react-redux'
// import { GetAllstagetypeData } from '../../Redux/Actions/StageTypeAction'
// import { Col, Row, Spinner } from 'react-bootstrap'
// import { Alert, Snackbar, useMediaQuery } from '@mui/material'
// import CopyToClipboard from 'react-copy-to-clipboard'
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import moment from 'moment'
// import { Link } from 'react-router-dom'
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from "@mui/material/styles";
// import AddIcon from '@mui/icons-material/Add';
// export const ShowAllStageType = () => {

//   const[userlogin,setuserlogin]=useState('')
//   const [loading, setLoading] = useState(true);

//           useEffect(()=>{
//             if(JSON.parse(localStorage.getItem("user"))!=null)
//             {
//               setuserlogin(JSON.parse(localStorage.getItem("user")))
//             }
//           },[])

// const dispatch=useDispatch()
// const theme = useTheme();
//        const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//         const run=async()=>{
//           setLoading(true)
//             await dispatch(GetAllstagetypeData())
//             setLoading(false)
//         }

//     useEffect(()=>{
//         run()
//     },[dispatch])

//     const res_get_allstagetype_data=useSelector(state=>state.AllStagetype.stagetype)
//     let res_get_stagetype_array = Array.isArray(res_get_allstagetype_data?.data) ? res_get_allstagetype_data.data : [];

//           //clipboard copy channal id
//         const [open, setOpen] = useState(false);
//         const handleCopy = () => {
//           setOpen(true);  // عرض رسالة تأكيد عند النسخ
//           setTimeout(() => setOpen(false), 2000);  // إخفاء الرسالة بعد 2 ثانية
//         };

// const homeRoute =
//   userlogin?.data?.role === 'Admin'
//     ? '/AllLeads'
//     :  userlogin?.data?.role === 'Marketer'
//     ? '/LeadsForMarketer'

//     : '/'; // fallback

//     const [columns, setColumns] = useState([
//       { key: 'copyId', label: 'Copy Id', visible: true, width: 120 },
//       { key: 'StageTypename', label: 'Stage Type Name', visible: true, width: 150 },
//       { key: 'Comment', label: 'Comment', visible: true, width: 120 },
//       { key: 'createdAt', label: 'Created At', visible: true, width: 180 },
//       { key: 'actions', label: 'Actions', visible: true, width: 150 },
//     ]);
//      const startResizing = (e, colIndex) => {
//       e.preventDefault();
//       const startX = e.clientX;
//       const startWidth = columns[colIndex].width;

//       const onMouseMove = (e) => {
//         const newWidth = Math.max(startWidth + e.clientX - startX, 50);
//         setColumns(prevCols => {
//           const newCols = [...prevCols];
//           newCols[colIndex] = { ...newCols[colIndex], width: newWidth };
//           return newCols;
//         });
//       };

//       const onMouseUp = () => {
//         document.removeEventListener('mousemove', onMouseMove);
//         document.removeEventListener('mouseup', onMouseUp);
//       };

//       document.addEventListener('mousemove', onMouseMove);
//       document.addEventListener('mouseup', onMouseUp);
//     };

//               const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <Container className='startpage'>
// <Row>
//   <Col sm="2"></Col>
//   <Col sm="10">

//   <div>
//   <Link
//     to={homeRoute}
//     style={{ textDecoration: 'none', color: '#102dff' }}
//   >
//     <span style={{ fontWeight: 'bold' }}>Home</span>
//   </Link>

//   <KeyboardDoubleArrowRightIcon />

//   <span>
//     <Link
//       to={`/Stages`}
//       style={{
//         color: mode === 'dark' ? '#ffffff' : '#666',
//         textDecoration: 'none',
//       }}
//     >
//       Go To Stages
//     </Link>
//   </span>
// </div>

// <div className='d-flex justify-content-end'>
// <Link to={`/AddNewTypeForstage`} style={{textDecoration:'none'}}>
//             <div style={{marginTop:'15px',textAlign:'center',background:"#102dff",color:"#fff",border:"1px solid #102dff",padding:"15px",borderRadius:"10px"}} className=' w-100'><AddIcon/> Add Type</div>
//             </Link>
// </div>

// <div style={{ marginBottom: '10px' }}>
//   {columns.map((col, index) => (
//     <label key={col.key} style={{ marginRight: '10px' }}>
//       <input
//         type="checkbox"
//         checked={col.visible}
//         onChange={() => {
//           const newCols = [...columns];
//           newCols[index].visible = !newCols[index].visible;
//           setColumns(newCols);
//         }}
//       /> {col.label}
//     </label>
//   ))}
// </div>

//        {loading ? (
//   <div className="text-center py-5">
//     <Spinner animation="border" variant="primary" />
//     <div className="mt-2 text-muted">Loading data...</div>
//   </div>
// ) : res_get_stagetype_array.length === 0 ? (
//   <div className="text-center py-5 text-muted">No data available</div>
// ) : (
//      <Table
//      size="sm"
//      responsive
//      style={{
//        minWidth: isExtraSmallScreen ? '800px' : '100%',
//        textAlign: 'center',
//        color: mode === 'dark' ? '#90caf9' : '#666',
//        backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//        borderCollapse: 'separate',
//        borderSpacing: '0',
//        borderRadius: '15px',
//        overflow: 'hidden',
//      }}
//      className={` ${mode === 'dark' ? 'table-dark' : 'table-light'}`}
//    >
//     <thead>
//     <tr>
//       {columns.filter(col => col.visible).map((col, index) => (
//         <th
//           key={col.key}
//           style={{
//             position: 'relative',
//             color: '#666',
//             minWidth: `${col.width}px`,
//             maxWidth: `${col.width}px`,
//             whiteSpace: 'nowrap',
//              borderBottom: '1px solid #ddd',
//       verticalAlign: 'middle',
//       textAlign: 'center',
//       padding: '12px 8px',
//           }}
//         >
//           {col.label}
//           <div
//             onMouseDown={(e) => startResizing(e, index)}
//             style={{
//               position: 'absolute',
//               right: 0,
//               top: 0,
//               height: '100%',
//               width: '5px',
//               cursor: 'col-resize',
//               userSelect: 'none',
//             }}
//           />
//         </th>
//       ))}
//     </tr>
//     </thead>
//   <tbody>
//   {res_get_stagetype_array && res_get_stagetype_array.length > 0 ? (
//     res_get_stagetype_array.map((item, index) => (
//       <tr key={item._id || index}>
//         {columns.filter(col => col.visible).map((col) => {
//           switch (col.key) {
//             case 'copyId':
//               return (
//                 <td key={col.key} style={{ color: "#102dff" }}>
//                   <CopyToClipboard onCopy={handleCopy}>
//                     <div onClick={() => navigator.clipboard.writeText(item._id)}>
//                       <ContentCopyIcon />
//                     </div>
//                   </CopyToClipboard>
//                   <Snackbar
//                     anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//                     open={open}
//                     autoHideDuration={2000}
//                   >
//                     <Alert severity="success">Copy Done</Alert>
//                   </Snackbar>
//                 </td>
//               );
//             case 'StageTypename':
//               return <td style={{color:"#666"}} key={col.key}>{item.name}</td>;
//             case 'Comment':
//               return <td style={{color:"#666"}} key={col.key}>{item.Comment || '-'}</td>;
//             case 'createdAt':
//               return (
//                 <td style={{color:"#666"}} key={col.key}>
//                   {item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY h:mm A') : '-'}
//                 </td>
//               );
//             case 'actions':
//               return <td style={{color:"#666"}} key={col.key}><StagesTypeActions stagetype={item} allstagestype={run}/></td>;
//             default:
//               return <td style={{color:"#666"}} key={col.key}>-</td>;
//           }
//         })}
//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td colSpan={columns.filter(col => col.visible).length} style={{ textAlign: 'center', padding: '20px' }}>
//         No Data Available
//       </td>
//     </tr>
//   )}
// </tbody>
//   </Table>
// )}
//   </Col>
// </Row>

//     </Container>
//   )
// }

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import { GetAllstagetypeData } from '../../Redux/Actions/StageTypeAction';
import { StagesTypeActions } from './StagesTypeActions';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconFilter  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>;
const IconCopy    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconPlus    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconTag     = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
const IconLayers  = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
const IconTrend   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const IconNote    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>;

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const ShowAllStageType = () => {
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [userlogin,    setUserlogin]    = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [searchTerm,   setSearchTerm]   = useState('');
  const [showFilter,   setShowFilter]   = useState(false);
  const [copyOpen,     setCopyOpen]     = useState(false);
  const [page,         setPage]         = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  const run = async () => {
    setLoading(true);
    await dispatch(GetAllstagetypeData());
    setLoading(false);
  };
  useEffect(() => { run(); }, [dispatch]);

  const res_get_allstagetype_data = useSelector((state) => state.AllStagetype.stagetype);
  const allTypes = Array.isArray(res_get_allstagetype_data?.data)
    ? res_get_allstagetype_data.data.filter((s) => s.name !== 'No Stage')
    : [];

  /* ── filter ── */
  const filtered = allTypes.filter((t) => {
    const q = searchTerm.toLowerCase();
    return !q || t.name?.toLowerCase().includes(q) || t.Comment?.toLowerCase().includes(q);
  });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  /* ── stats ── */
  const newestType = allTypes.length
    ? allTypes.reduce((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? a : b)
    : null;

  const homeLink =
    userlogin?.data?.role === 'Admin'    ? '/AllLeadsForAdmin'
  : userlogin?.data?.role === 'Marketer' ? '/ALLLeadsForMarketer'
  : '/';

  const clearFilter = () => { setSearchTerm(''); setPage(1); };

  /* ── page numbers ── */
  const buildPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page <= 4)                   pages.push(1, 2, 3, 4, 5, '...', totalPages);
    else if (page >= totalPages - 3) pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    else                             pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    return pages;
  };

  /* ── type badge color (cycle) ── */
  const getBadgeStyle = (name) => {
    const palette = [
      { bg: isDark ? 'rgba(99,102,241,0.12)'  : 'rgba(99,102,241,0.08)',  color: isDark ? '#a5b4fc' : '#0D47A1',  border: isDark ? 'rgba(99,102,241,0.25)'  : 'rgba(99,102,241,0.2)'  },
      { bg: isDark ? 'rgba(16,185,129,0.12)'  : 'rgba(16,185,129,0.08)',  color: isDark ? '#6ee7b7' : '#059669',  border: isDark ? 'rgba(16,185,129,0.25)'  : 'rgba(16,185,129,0.2)'  },
      { bg: isDark ? 'rgba(245,158,11,0.12)'  : 'rgba(245,158,11,0.08)',  color: isDark ? '#fcd34d' : '#d97706',  border: isDark ? 'rgba(245,158,11,0.25)'  : 'rgba(245,158,11,0.2)'  },
      { bg: isDark ? 'rgba(239,68,68,0.12)'   : 'rgba(239,68,68,0.08)',   color: isDark ? '#fca5a5' : '#dc2626',  border: isDark ? 'rgba(239,68,68,0.25)'   : 'rgba(239,68,68,0.2)'   },
      { bg: isDark ? 'rgba(14,165,233,0.12)'  : 'rgba(14,165,233,0.08)',  color: isDark ? '#7dd3fc' : '#0284c7',  border: isDark ? 'rgba(14,165,233,0.25)'  : 'rgba(14,165,233,0.2)'  },
    ];
    if (!name) return palette[0];
    return palette[name.charCodeAt(0) % palette.length];
  };

  return (
    <>
      <style>{`
        .stt-row:hover { background-color: ${isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)'} !important; }
        .stt-action-btn {
          display:inline-flex;align-items:center;justify-content:center;
          width:30px;height:30px;border-radius:8px;border:none;cursor:pointer;
          background:${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'};
          color:${isDark ? '#9ca3af' : '#6b7280'};transition:all 0.15s;
        }
        .stt-action-btn:hover {
          background:${isDark ? 'rgba(99,102,241,0.2)' : 'rgba(99,102,241,0.1)'};
          color:${isDark ? '#a5b4fc' : '#0D47A1'};
        }
        .stt-create-btn {
          display:inline-flex;align-items:center;gap:6px;
          padding:8px 16px;border-radius:10px;border:none;cursor:pointer;font-size:13px;
          font-weight:600;font-family:'DM Sans',sans-serif;
          background:linear-gradient(135deg,#0D47A1,#0D47A1);color:#fff;
          transition:all 0.2s;white-space:nowrap;
          box-shadow:0 2px 8px rgba(37,99,235,0.35);
        }
        .stt-create-btn:hover{transform:translateY(-1px);box-shadow:0 4px 14px #0D47A1}
        .stt-filter-btn {
          display:inline-flex;align-items:center;gap:6px;
          padding:8px 14px;border-radius:10px;border:none;cursor:pointer;font-size:13px;
          font-weight:600;font-family:'DM Sans',sans-serif;
          background:${isDark ? 'rgba(255,255,255,0.06)' : '#fff'};
          color:${isDark ? '#9ca3af' : '#6b7280'};
          border:1px solid ${isDark ? '#2a2f45' : '#e2e8f0'};transition:all 0.15s;
        }
        .stt-filter-btn:hover{background:${isDark ? 'rgba(255,255,255,0.1)' : '#f1f5f9'};}
        .stt-search-inline {
          display:flex;align-items:center;gap:8px;padding:8px 14px;border-radius:10px;
          background:${isDark ? 'rgba(255,255,255,0.05)' : '#fff'};
          border:1px solid ${isDark ? '#2a2f45' : '#e2e8f0'};
          color:${isDark ? '#9ca3af' : '#94a3b8'};
        }
        .stt-search-inline input {
          border:none;outline:none;background:transparent;font-size:13px;
          font-family:'DM Sans',sans-serif;color:${isDark ? '#e5e7eb' : '#1f2937'};width:220px;
        }
        .stt-search-inline input::placeholder{color:${isDark ? '#4b5563' : '#94a3b8'};}
        .stt-checkbox{width:15px;height:15px;border-radius:4px;cursor:pointer;accent-color:#0D47A1;}
        .stt-pag-btn {
          min-width:32px;height:32px;border-radius:8px;border:none;cursor:pointer;
          font-size:13px;font-family:'DM Sans',sans-serif;font-weight:500;
          background:transparent;color:${isDark ? '#9ca3af' : '#6b7280'};transition:all 0.15s;
          display:inline-flex;align-items:center;justify-content:center;padding:0 6px;
        }
        .stt-pag-btn:hover:not(:disabled){background:${isDark ? 'rgba(99,102,241,0.15)' : 'rgba(37,99,235,0.08)'};color:${isDark ? '#a5b4fc' : '#1d4ed8'};}
        .stt-pag-btn.active{background:#0D47A1;color:#fff;font-weight:700;}
        .stt-pag-btn:disabled{opacity:0.3;cursor:not-allowed;}
        .stt-pag-ellipsis{color:${isDark ? '#4b5563' : '#94a3b8'};padding:0 4px;font-size:14px;}
        .stt-page-select {
          background:${isDark ? '#151827' : '#fff'};
          border:1px solid ${isDark ? '#2a2f45' : '#e2e8f0'};
          color:${isDark ? '#e5e7eb' : '#1f2937'};
          font-family:'DM Sans',sans-serif;cursor:pointer;padding:4px 8px;border-radius:6px;font-size:12px;
        }
        /* stat cards */
        .stt-stat-card{flex:1;min-width:200px;padding:20px 22px;border-radius:16px;display:flex;align-items:flex-start;justify-content:space-between;gap:12px;}
        .stt-stat-card.light{background:${isDark ? '#1a1d2e' : '#ffffff'};border:1px solid ${isDark ? '#2a2f45' : '#e8eaf0'};box-shadow:${isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)'};}
        .stt-stat-card.dark-card{background:linear-gradient(135deg,#1e3a8a 0%,#0D47A1 60%,#0D47A1 100%);border:none;box-shadow:0 4px 20px #0D47A1}
        .stt-stat-label{font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;margin-bottom:6px;color:${isDark ? '#6b7280' : '#94a3b8'};}
        .stt-stat-label.white{color:rgba(255,255,255,0.7);}
        .stt-stat-value{font-size:28px;font-weight:800;letter-spacing:-0.5px;color:${isDark ? '#f9fafb' : '#111827'};font-family:'DM Sans',sans-serif;}
        .stt-stat-value.white{color:#ffffff;}
        .stt-stat-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border-radius:20px;font-size:11px;font-weight:600;margin-top:10px;}
        .stt-stat-badge.green{background:${isDark ? 'rgba(16,185,129,0.12)' : 'rgba(16,185,129,0.1)'};color:${isDark ? '#6ee7b7' : '#059669'};}
        .stt-badge-pill{background:rgba(255,255,255,0.2);color:#fff;font-size:10px;font-weight:700;letter-spacing:0.06em;padding:3px 8px;border-radius:20px;}
        .stt-stat-icon{width:44px;height:44px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
        .stt-stat-icon.light-icon{background:${isDark ? 'rgba(37,99,235,0.12)' : 'rgba(37,99,235,0.08)'};color:${isDark ? '#93c5fd' : '#0D47A1'};}
        .stt-stat-icon.dark-icon{background:rgba(255,255,255,0.15);color:#fff;}
        /* table */
        .stt-table{width:100%;border-collapse:collapse;font-family:'DM Sans',sans-serif;}
        .stt-table thead tr{border-bottom:1px solid ${isDark ? '#2a2a45' : '#e8eaf0'};}
        .stt-table th{padding:11px 16px;text-align:left;font-size:11px;font-weight:700;letter-spacing:0.07em;text-transform:uppercase;color:${isDark ? '#4b5563' : '#94a3b8'};background:${isDark ? '#1a1a2e' : '#ffffff'};white-space:nowrap;}
        .stt-table td{padding:13px 16px;font-size:13px;color:${isDark ? '#d1d5db' : '#374151'};border-bottom:1px solid ${isDark ? '#1e2035' : '#f1f3f8'};vertical-align:middle;}
        .stt-type-cell{display:flex;align-items:center;gap:10px;}
        .stt-type-thumb{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0;background:linear-gradient(135deg,#0D47A1,#0D47A1);color:#fff;}
        .stt-type-name{font-weight:600;color:${isDark ? '#f3f4f6' : '#111827'};font-size:13px;}
        .stt-cell-muted{color:${isDark ? '#6b7280' : '#9ca3af'} !important;}
        .stt-comment-cell{max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:${isDark ? '#9ca3af' : '#6b7280'} !important;font-size:12px !important;}
        .stt-empty{text-align:center;padding:60px 20px !important;color:${isDark ? '#4b5563' : '#94a3b8'} !important;}
        .stt-spinner{width:28px;height:28px;border:3px solid ${isDark ? '#2a2f45' : '#e2e8f0'};border-top-color:#0D47A1;border-radius:50%;animation:stt-spin 0.7s linear infinite;margin:0 auto 10px;}
        @keyframes stt-spin{to{transform:rotate(360deg);}}
        .stt-table-section{background:${isDark ? '#1a1a2e' : '#ffffff'};border-radius:18px;border:1px solid ${isDark ? '#2a2a45' : '#e8eaf0'};box-shadow:${isDark ? 'none' : '0 2px 16px rgba(0,0,0,0.06)'};overflow:hidden;display:flex;flex-direction:column;}
        .stt-table-header{padding:18px 20px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;border-bottom:1px solid ${isDark ? '#2a2a45' : '#f1f3f8'};}
        .stt-table-title-label{font-size:10px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:${isDark ? '#4b5563' : '#94a3b8'};margin-bottom:2px;}
        .stt-table-title{font-size:18px;font-weight:800;color:${isDark ? '#f9fafb' : '#111827'};letter-spacing:-0.3px;}
        .stt-table-actions{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
        .stt-table-wrap{flex:1;overflow-y:auto;overflow-x:auto;}
        .stt-pagination{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;flex-wrap:wrap;gap:10px;}
        .stt-pagination-info{display:flex;align-items:center;gap:10px;font-size:12px;color:${isDark ? '#6b7280' : '#9ca3af'};font-family:'DM Sans',sans-serif;}
        .stt-pagination-btns{display:flex;align-items:center;gap:4px;}
      `}</style>

      <div style={{
        position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
        backgroundColor: isDark ? '#0f1117' : '#f0f2f5',
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
      }}>

        {/* ── Breadcrumb ── */}
        <div style={{
          padding: '14px 28px', flexShrink: 0,
          backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
          display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
        }}>
          <Link to={homeLink} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Home</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <Link to="/Stages" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Stages</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Stage Types</span>
        </div>

        {/* ── Scrollable body ── */}
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>

          {/* Stats */}
          <section style={{ padding: '24px 28px 0', flexShrink: 0, display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <div className="stt-stat-card light">
              <div>
                <div className="stt-stat-label">TOTAL TYPES</div>
                <div className="stt-stat-value">{allTypes.length}</div>
                <div className="stt-stat-badge green">↑ Defined categories</div>
              </div>
              <div className="stt-stat-icon light-icon"><IconTag /></div>
            </div>

            <div className="stt-stat-card light">
              <div>
                <div className="stt-stat-label">WITH COMMENTS</div>
                <div className="stt-stat-value">{allTypes.filter((t) => t.Comment).length}</div>
                <div className="stt-stat-badge green">Documented types</div>
              </div>
              <div className="stt-stat-icon light-icon"><IconLayers /></div>
            </div>

            <div className="stt-stat-card dark-card">
              <div>
                <div className="stt-stat-label white">LATEST TYPE</div>
                <div className="stt-stat-value white" style={{ fontSize: 18, marginTop: 4 }}>
                  {newestType?.name || '—'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
                  <span className="stt-badge-pill">MOST RECENT</span>
                  <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>
                    {newestType ? moment(newestType.createdAt).format('MMM DD, YYYY') : ''}
                  </span>
                </div>
              </div>
              <div className="stt-stat-icon dark-icon"><IconTrend /></div>
            </div>
          </section>

          {/* Table Section */}
          <section
            className="stt-table-section"
            style={{ margin: '24px 28px', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}
          >
            {/* header */}
            <div className="stt-table-header">
              <div>
                <div className="stt-table-title-label">PIPELINE</div>
                <div className="stt-table-title">STAGE TYPES</div>
              </div>
              <div className="stt-table-actions">
                <div className="stt-search-inline">
                  <IconSearch />
                  <input
                    placeholder="Search by name or comment…"
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setPage(1); }}
                  />
                </div>
                <button className="stt-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                  <IconFilter /> Filter
                </button>
                <Link to="/AddNewTypeForstage" style={{ textDecoration: 'none' }}>
                  <button className="stt-create-btn"><IconPlus /> Add Type</button>
                </Link>
              </div>
            </div>

            {/* Filter Row */}
            {showFilter && (
              <div style={{
                flexShrink: 0, padding: '14px 20px',
                backgroundColor: isDark ? '#161929' : '#f8fafc',
                borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <span style={{ fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>
                  Showing{' '}
                  <strong style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{filtered.length}</strong>
                  {' '}of{' '}
                  <strong style={{ color: isDark ? '#e5e7eb' : '#1f2937' }}>{allTypes.length}</strong> types
                  {searchTerm && <span style={{ marginLeft: '8px' }}>for "<em>{searchTerm}</em>"</span>}
                </span>
                <button
                  onClick={clearFilter}
                  style={{
                    padding: '6px 14px', borderRadius: '8px', cursor: 'pointer', fontSize: '12px',
                    fontWeight: 600, fontFamily: "'DM Sans',sans-serif",
                    background: 'transparent', color: isDark ? '#9ca3af' : '#6b7280',
                    border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`, transition: 'all 0.15s',
                  }}
                >
                  Clear
                </button>
              </div>
            )}

            {/* Table */}
            <div className="stt-table-wrap">
              <table className="stt-table">
                <thead>
                  <tr>
                    <th style={{ width: 40 }}><input type="checkbox" className="stt-checkbox" /></th>
                    <th>TYPE NAME</th>
                    <th>COMMENT</th>
                    <th>CREATED DATE</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan={5} className="stt-empty"><div className="stt-spinner" /><span>Loading types…</span></td></tr>
                  ) : pageItems.length === 0 ? (
                    <tr><td colSpan={5} className="stt-empty">
                      <div style={{ marginBottom: '8px', opacity: 0.4 }}><IconTag /></div>
                      <p style={{ margin: 0 }}>{searchTerm ? 'No types match your search' : 'No stage types found'}</p>
                    </td></tr>
                  ) : (
                    pageItems.map((item, i) => {
                      const badge = getBadgeStyle(item.name);
                      return (
                        <tr key={item._id || i} className="stt-row">
                          <td><input type="checkbox" className="stt-checkbox" /></td>
                          <td>
                            <div className="stt-type-cell">
                              <div className="stt-type-thumb">
                                {item.name?.slice(0, 2).toUpperCase() || 'TY'}
                              </div>
                              <div>
                                <div className="stt-type-name">{item.name || '—'}</div>
                                <span style={{
                                  display: 'inline-flex', alignItems: 'center',
                                  padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: 600, marginTop: '3px',
                                  backgroundColor: badge.bg, color: badge.color,
                                  border: `1px solid ${badge.border}`,
                                }}>
                                  Type
                                </span>
                              </div>
                            </div>
                          </td>
                          <td>
                            {item.Comment ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span style={{ color: isDark ? '#6b7280' : '#94a3b8', display: 'flex' }}><IconNote /></span>
                                <span className="stt-comment-cell">{item.Comment}</span>
                              </div>
                            ) : (
                              <span style={{ color: isDark ? '#374151' : '#d1d5db' }}>—</span>
                            )}
                          </td>
                          <td className="stt-cell-muted" style={{ fontSize: 13 }}>
                            {item.createdAt ? moment(item.createdAt).format('MMM DD, YYYY') : '—'}
                          </td>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <CopyToClipboard
                                text={item._id}
                                onCopy={() => { setCopyOpen(true); setTimeout(() => setCopyOpen(false), 2000); }}
                              >
                                <button className="stt-action-btn" title="Copy ID"><IconCopy /></button>
                              </CopyToClipboard>
                              <StagesTypeActions stagetype={item} allstagestype={run} />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {filtered.length > 0 && (
              <div
                className="stt-pagination"
                style={{
                  flexShrink: 0,
                  backgroundColor: isDark ? '#1a1a2e' : '#ffffff',
                  borderTop: `1px solid ${isDark ? '#2a2a45' : '#e8eaf0'}`,
                  boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
                }}
              >
                <div className="stt-pagination-info">
                  <span>Items per page:</span>
                  <select
                    className="stt-page-select"
                    value={itemsPerPage}
                    onChange={(e) => { setItemsPerPage(Number(e.target.value)); setPage(1); }}
                  >
                    {[5, 10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                  <span>
                    Showing <strong>{(page - 1) * itemsPerPage + 1}–{Math.min(page * itemsPerPage, filtered.length)}</strong>
                    {' '}of <strong>{filtered.length}</strong> types
                  </span>
                </div>
                <div className="stt-pagination-btns">
                  <button className="stt-pag-btn" onClick={() => setPage(1)} disabled={page === 1}>⟨|</button>
                  <button className="stt-pag-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>‹</button>
                  {buildPageNumbers().map((n, idx) =>
                    n === '...'
                      ? <span key={`e-${idx}`} className="stt-pag-ellipsis">…</span>
                      : <button key={n} className={`stt-pag-btn ${page === n ? 'active' : ''}`} onClick={() => setPage(n)}>{n}</button>
                  )}
                  <button className="stt-pag-btn" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>›</button>
                  <button className="stt-pag-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>|⟩</button>
                </div>
              </div>
            )}
          </section>

          {/* Footer */}
          <footer style={{ padding: '16px 28px', flexShrink: 0, fontSize: '12px', color: isDark ? '#374151' : '#d1d5db' }}>
            © 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.
          </footer>
        </div>
      </div>

      <Snackbar open={copyOpen} autoHideDuration={2000} onClose={() => setCopyOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="success" sx={{ width: '100%' }}>Copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};
